
























































import { Vue, Component } from 'vue-property-decorator'
import { makeToast } from '@/modules/budget/monitoring/reports-constructor/common/utils/otherUtils'
import { nameMap } from '@/modules/budget/monitoring/reports-constructor/common/nameMap'
import { JournalResponse } from '../../common/types/JournalResponse'
import { JournalRecord } from '../../common/types/JournalRecord'
import { ReportName } from '../../common/types/roots/fields'
import { FilterSettings } from '../../common/types/roots/FilterSettings'
import i18nService from "@/services/i18n";
import { allDataSourcesOptions, allMeasureUnitsOptions, allMutuallyRedeemingOptions, allReportNamesOptions, allReportTypesOptions } from '../../common/baseOptions'
import { Option } from "../../common/types/Option"

const tempTableFields: { key: (keyof JournalRecord | 'action') }[] = [
    { key: 'id' },
    { key: 'name' },
    { key: 'reportType' },
    { key: 'year' },
    { key: 'region' },
    { key: 'cls' },
    { key: 'pcl' },
    { key: 'abp' },
    { key: 'gu' },
    { key: 'prg' },
    { key: 'mutuallyRedeeming' },
    { key: 'measureUnit' },
    { key: 'dataSource' },
    { key: 'username' },
    { key: 'creationTimestamp' },
    { key: 'status' },
    { key: 'action' }
]

interface KeycloakUser {
    id: string;
    username: string;
    firstName: string;
    lastName: string;
    emailVerified: boolean;
    createdTimestamp: number;
    enabled: boolean;
    access: {
        manageGroupMembership: boolean;
        view: boolean;
        mapRoles: boolean;
        impersonate: boolean;
        manage: boolean;
    }
    createdTime: string;
}

@Component
export default class Journal extends Vue {

    public records: JournalRecord[] = []

    public progress = 100

    public readonly tableFields = tempTableFields
    
    public readonly perPage = 30
    public currentPage = 1
    public totalCount = 0

    private intervalId: number | null = null
    private timeouts: number[] = []
    private usersMap: Map<string, KeycloakUser> = new Map()

    public tempI18Service: any = null

    public async onPageChange(page: number) {
        this.currentPage = page
        await this.loadJournalRecords()
    }

    public updateTabRef(tabRef: string) {
        this.$emit('update-tab-ref', tabRef);
    }

    public handleSetReportParams(params: any) {
        this.$emit("set-report-params", params)
    }

    get userId(): string {
        return this.$store.state.user.sub;
    }

    private async created() {
        await this.loadUsers()
        this.tempI18Service = i18nService
        await this.loadJournalRecords()
        this.startProgressivePollingInProcessEntries()
    }

    private async loadUsers() {
        try {
            const response = await fetch('/api-py/get-realm-users-include-disabled')
            const data = await response.json()
            const usersById = new Map<string, KeycloakUser>(
                data.map((u: any) => [u.id, u])
            )
            this.usersMap = usersById
        } catch (error) {
            console.error(error)
        }
    }

    private beforeDestroy() {
        this.stopPingingInProcessEntries()
    }

    /** Метод-обертка для $t */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
        const text: string = String(this.$t(`${translationKey}.${key}`))

        return text
    }

    public getNameMap(mapItem: any, key: string): string {
        // TODO: Array.isArray(mapItem)
        if (typeof mapItem === 'object' && (mapItem ?? false)) {
            let label = ''
            mapItem.forEach((item: any, index: number) => {
                label += item
                if ((index + 1) !== mapItem.length) {
                    label += ', '
                }
            })

            return label
        }

        // @ts-ignore
        const getLabel = (options: Option<any>[], value: string): string => {
            const option = options.find(o => o.value === value)
            if (!value || !option) {
                return ''
            }
            return this.getOptionLabel(option)
        };

        switch (key) {
            case 'reportType':
                return getLabel(allReportTypesOptions, mapItem);
            case 'mutuallyRedeeming':
                return getLabel(allMutuallyRedeemingOptions, mapItem);
            case 'measureUnit':
                return getLabel(allMeasureUnitsOptions, mapItem);
            case 'dataSource':
                return getLabel(allDataSourcesOptions, mapItem);
            case 'status':
                return this.tr('journal.' + mapItem)
        }

        const label = nameMap[mapItem]
        if (typeof label === 'string') {
            return label
        }

        if (key === 'creationTimestamp') {
            return this.formatDateString(mapItem)
        }

        return mapItem
    }

    private async checkInProgressAndLoadJournalEntries() {
        const isInProgressPresent = Boolean(this.records.find(it => it.status === 'IN_PROGRESS'))
        if (!isInProgressPresent) {
            return
        }

        await this.loadJournalRecords()
    }


    private async fetchJournalRecords(userId: string, page: number, pageSize: number): Promise<{
        records: JournalResponse[]
        totalCount: number
    }> {
        const searchParams = new URLSearchParams()
        searchParams.append('user_id', userId)
        searchParams.append('page', page.toString()) // page starts from 1
        searchParams.append('page_size', pageSize.toString())

        const response = await fetch(`/api-py/monitoring/reports-constructor/journal?${searchParams}`)

        if (!response.ok) {
            const errorData = await response.json().catch(() => null); 
            const errorText = await response.text().catch(() => 'No text');
            console.error(`Error ${response.status}:`, errorData || errorText);
            makeToast(this, this.tr('toasts.' + 'error_load_journal'), this.tr('toasts.' + 'error'), 'danger')
            return {
                records: [],
                totalCount: 0
            }
        }
        const responseBody: { items: JournalResponse[], total_count: number } = await response.json()
        return {
            records: responseBody.items,
            totalCount: responseBody.total_count
        }
    }

    private async loadJournalRecords() {
        try {
            this.progress = 50
            
            const responseData = await this.fetchJournalRecords(this.userId, this.currentPage, this.perPage)
            this.progress = 70

            this.totalCount = responseData.totalCount
            this.records = this.convertToJournalEntries(responseData.records)
        } catch (error) {
            console.error(error)
            makeToast(this, this.tr('toasts.' + 'error_load_journal'), this.tr('toasts.' + 'error'), 'danger')
        } finally {
            this.progress = 100
        }
    }

    private convertToJournalEntries(responseRecords: JournalResponse[]): JournalRecord[] {
        const records: JournalRecord[] = responseRecords.map(responseItem => {
            let region: string = ''
            if ('region' in responseItem.filter_settings && responseItem.filter_settings.region) {
                region = responseItem.filter_settings.region
            } else if ('regions' in responseItem.filter_settings) {
                region = responseItem.filter_settings.regions.reduce((acc, current) => {
                    return `${acc}, ${current}`
                }, '')
                .substring(1)
                .trim()
            }

            let status: LoadStatus = 'ERROR'
            if (responseItem.progress >= 100) {
                status = 'COMPLETE'
            } else if (responseItem.progress < 100 && responseItem.progress >= 0) {
                status = 'IN_PROGRESS'
            }

            // TODO: Make all 'record.name' to contain extension on table column
            let filename: string | null = null
            let name: string = responseItem.name
            if (responseItem.name.endsWith('.zip') || responseItem.name.endsWith('.xls') || responseItem.name.endsWith('.xlsx')) {
                name = name.substring(0, name.length - 4)
                filename = responseItem.name
            }

            const user = this.usersMap.get(responseItem.user_id)
            const username = user ? `${user.lastName??''} ${user.firstName??''}` : ''

            const record: JournalRecord = {
                id: responseItem.id,
                name: name,
                templateName: name,
                reportName: responseItem.filter_settings.reportName,
                reportType: responseItem.filter_settings.reportType,
                year: 'year' in responseItem.filter_settings ? responseItem.filter_settings.year : null,
                region: region,
                classificationType: responseItem.filter_settings.classificationType,
                cls: this.getKbkCodes(responseItem.filter_settings, 'incomes', 'cls'),
                pcl: this.getKbkCodes(responseItem.filter_settings, 'incomes', 'pcl'),
                abp: this.getKbkCodes(responseItem.filter_settings, 'expenses', 'abp'),
                gu: this.getKbkCodes(responseItem.filter_settings, 'expenses', 'gu'),
                prg: this.getKbkCodes(responseItem.filter_settings, 'expenses', 'prg'),
                mutuallyRedeeming: 'mutuallyRedeeming' in responseItem.filter_settings ? responseItem.filter_settings.mutuallyRedeeming : null,
                measureUnit: 'measureUnit' in responseItem.filter_settings ? responseItem.filter_settings.measureUnit : null,
                dataSource: 'dataSource' in responseItem.filter_settings ? responseItem.filter_settings.dataSource : null,
                username: username,
                creationTimestamp: responseItem.creation_timestamp,
                status: status,
                progress: responseItem.progress,
                filename: filename,
                filterSettings: responseItem.filter_settings
            }

            if (responseItem.filter_settings.reportName === 'CASH-EXEC') {
                if ('regionName' in responseItem.filter_settings) {
                    const reportName = this.getOptionLabel(allReportNamesOptions.find(o => o.value === 'CASH-EXEC')!)
                    record.name = `${reportName} (${(responseItem.filter_settings as any)['regionName']})`
                }
            }

            return record
        })

        return records
    }

    private getKbkCodes(filterSettings: FilterSettings, key: 'incomes' | 'expenses', subkey: string): string | null {
        try {
            if (key in filterSettings) {
                // @ts-ignore
                let selectedCodes = filterSettings[key]?.find((it) => it.key === subkey)?.selected

                if (selectedCodes == null) {
                    return null
                }

                if (selectedCodes && !Array.isArray(selectedCodes)) {
                    selectedCodes = [selectedCodes]
                }

                // @ts-ignore
                return selectedCodes.reduce((acc, current) => `${acc}, ${current}`, '').substring(1).trim()
            }
            return null
        } catch (error) {
            console.error(error)
            return 'Ошибка получения кодов'
        }
    }

    public async downloadReport(record: JournalRecord) {
        makeToast(this, this.tr('toasts.' + 'download_starting_wait'), this.tr('toasts.' + 'warning_title') + '!', 'info')
        this.progress = 10
        try {
            this.progress = 50
            const response = await fetch(`/api-py/monitoring/reports-constructor/journal/file/${record.id}`)
            if (!response.ok) {
                throw new Error('error')
            }

            let filename: string = ''
            if (record.filename) {
                filename = record.filename
            } else {
                const name = this.getReportFilename(record)
                const extension = this.getExtension(record)  // TODO: move towards including extension in table column 'name'
                filename = `${name}.${extension}`
            }

            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_load_report'), this.tr('toasts.' + 'error'), 'danger')
        } finally {
            this.progress = 100
        }
    }

    private getReportFilename(record: JournalRecord): string {
        if (record.reportName === 'DVI') {
            if (record.classificationType === 'INCOMES') {
                return "Динамика внесенных изменений в план поступлений годовые изменения"
            } else if (record.classificationType === 'EXPENSES') {
                return "Динамика внесенных изменений в план финансирования годовые изменения"
            }
            return record.name
        } else if (record.reportName === '2-43') {
            const date = new Date(record.creationTimestamp);
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const str = ` ${yyyy}-${mm}-${dd} ${hh}-${min}`;
            return record.name + str
        }

        if (record.reportName === 'DKI-P' || record.reportName === 'CASH-EXEC') {
            const regionName = (record.filterSettings as any)?.regionName
            const baseName = record.templateName ?? record.name
            if (record.region && regionName) {
                return `${baseName}_${record.region}_${regionName}`
            }
        }

        return record.name
    }

    public async stopReportFormation(record: JournalRecord) {
        try {
            const response = await fetch(`/api-py/monitoring/reports-constructor/journal/stop/${record.id}`)
            if (!response.ok) {
                throw new Error('error')
            }
            await this.loadJournalRecords()
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_load_report'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    private startProgressivePollingInProcessEntries() {
        // Immediate call
        this.checkInProgressAndLoadJournalEntries()

        // After 3 seconds
        this.timeouts.push(setTimeout(() => {
            this.checkInProgressAndLoadJournalEntries()
            // After 6 seconds
            this.timeouts.push(setTimeout(() => {
                this.checkInProgressAndLoadJournalEntries()
                // Every 15 seconds indefinitely
                this.intervalId = setInterval(this.checkInProgressAndLoadJournalEntries, 15_000)
            }, 6_000))
        }, 3_000))
    }

    private stopPingingInProcessEntries() {
        if (this.intervalId != null) {
            clearInterval(this.intervalId)
            this.intervalId = null
        }
        this.timeouts.forEach(clearTimeout)
        this.timeouts = []
    }

    // TODO: move to dateUtils
    private formatDateString(dateString: string): string {
        const date = new Date(dateString);

        // Extract date components
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        // Extract time components
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        // Format the date and time components into the desired format
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    private getExtension(record: JournalRecord): string {
        // xls
        let extension = 'xls'

        // xlsx
        const xlsxReports: ReportName[] = [
            'IRBO',
            'DVI',
            'IPIPM',
            '1-27-ACT',
            'DKI-P',
            'DKI-R',
            'EIB',
            'INCOME',
            'income_kbk',
            'CASH-EXEC',
            'RS',
            'RT',
            'RECON-STATEMENT',
            'SVOD-PLAN',
            'SVOD-DOH',
            'BR',
            'MBSP',
            'LOAN-STATUS',
            '2-43',
            'KSN',
            'SVOD-RAS',
            'OWN-INCOME',
            'SVOD-MB',
            'KF219-CO',
        ]
        if (xlsxReports.includes(record.reportName)) {
            extension = 'xlsx'
        }

        // zip
        if (
            record.name.toLowerCase() === 'пакет отчетности об исполнении бюджета'
            || record.name.toLowerCase() === 'справки поступления'
            || record.name.toLowerCase() === 'түсімдер анықтамалары'
            || record.name.toLowerCase() === 'справки обязательства'
            || record.name.toLowerCase() === 'міндеттемелер анықтамалары'
            || record.name.toLowerCase() === 'справки платежи'
        ) {
            extension = 'zip'
        }

        // For newer 1-27(-DAILY)
        if ((record.reportName === '1-27' || record.reportName === '1-27-DAILY') && 'excelVersion' in record.filterSettings) {
            extension = 'xlsx'
        }

        return extension
    }

    getStatusStyle(status: LoadStatus): string {
        switch (status) {
            case 'COMPLETE': return 'status-completed';
            case 'IN_PROGRESS': return 'status-in-progress';
            case 'ERROR': return 'status-error';
            default: return ''
        }
    }


    private getOptionLabel(option: Option<any>) : string {
        switch (this.tempI18Service.locale) {
            case 'kk':
                return option.labelKk || option.label || '';
            case 'en':
                return option.labelEn || option.label || '';
            case 'ru':
            default:
                return option.label || '';
        }
    }
}
